<div class="row">
  <!-- JSONVIEWER IF BLOCK -->

  <div class="col-md-12 pos-relative">
    <div class="json-detail">
      <f-data-card>
        <div class="row">
          <div class="col-md-12">
            <h5 class="subheading">
              View JSON
            </h5>
          </div>
        </div>
        <section class="error-wrapper" *ngIf="rootScope.activeCustTab.viewJsonData.apiFailed === true">
          <f-alert variant="error">
            <p>
              {{ apiFailureMsg }}
            </p>
          </f-alert>
        </section>

        <div class="row" *ngIf="rootScope.activeCustTab.viewJsonData.apiFailed === false">
          <div class="left-panel">
            <ul class="card-list">
              <li [ngClass]="{ 'tab-active': rootScope.activeCustTab.viewJsonData.selectedAPIName === each }"
                *ngFor="let each of rootScope.activeCustTab.viewJsonData.apiNameList">
                <button class="navlinks" (click)="onAPINameClick(each)"> 
                  <f-icon icon-config='{"iconName": "file-code", "iconType": "light", "iconSize": "s"}'></f-icon> {{ each }}</button>
              </li>
            </ul>
          </div>
          <div class="right-panel">
            <div class="container form">
              <div class="row">
                <div class="col-md-12">
                  <h5 class="subheading subheading-bg">{{ rootScope.activeCustTab.viewJsonData.selectedAPIName }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="json-viewer">
                    <pre class="json-viewer-content">
                          {{ getSelectedAPIData() | json }}
                      </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </f-data-card>
    </div>
  </div>

</div>